import { Injectable, inject, LOCALE_ID } from '@angular/core';


/** E.164 digits only, without the leading plus (Argentina). */
const ICORTEX_WHATSAPP_PHONE_DIGITS = '5491170652267';

/** Pre-filled chat text for expert CTAs, keyed by Angular LOCALE_ID. */
const ICORTEX_WHATSAPP_EXPERT_PREFILL_BY_LOCALE: Record<string, string> = {
  'en-US': 'Hello, I need support for implementing the iCortex protocol.',
  es: 'Hola, necesito soporte para la implementación del protocolo de iCortex',
  pt: 'Olá, preciso de suporte para a implementação do protocolo iCortex.',
  ko: '안녕하세요, iCortex 프로토콜 구현 지원이 필요합니다.'
};

/** Pre-filled chat text for the Contact page live support CTA. */
const ICORTEX_WHATSAPP_LIVE_SUPPORT_PREFILL_BY_LOCALE: Record<string, string> = {
  'en-US': 'Hello, I need live support with iCortex.',
  es: 'Hola, necesito soporte en vivo con iCortex.',
  pt: 'Olá, preciso de suporte ao vivo com o iCortex.',
  ko: '안녕하세요, iCortex 라이브 지원이 필요합니다.'
};


/**
 * @description Builds WhatsApp Web send URLs with locale-specific pre-filled messages.
 */
@Injectable( {
  providedIn: 'root'
} )
export class IcortexWhatsappLinkService {

  private readonly localeId = inject( LOCALE_ID );


  /**
   * @description Returns the send URL for expert-style CTAs (Talk to an Expert).
   * @return Full https://web.whatsapp.com/send URL including encoded text.
   */
  getExpertWhatsappWebUrl(): string {

    return this.buildSendUrl( ICORTEX_WHATSAPP_EXPERT_PREFILL_BY_LOCALE );
  }


  /**
   * @description Returns the send URL for the Contact page Access Live Support CTA.
   * @return Full https://web.whatsapp.com/send URL including encoded text.
   */
  getLiveSupportWhatsappWebUrl(): string {

    return this.buildSendUrl( ICORTEX_WHATSAPP_LIVE_SUPPORT_PREFILL_BY_LOCALE );
  }


  /**
   * @description Resolves pre-filled text for the active locale with English fallback.
   * @param table Map of LOCALE_ID to message body.
   * @return WhatsApp Web send URL.
   */
  private buildSendUrl( table: Record<string, string> ): string {

    const message = table[ this.localeId ] ?? table[ 'en-US' ];
    const params = new URLSearchParams();

    params.set( 'phone', ICORTEX_WHATSAPP_PHONE_DIGITS );
    params.set( 'text', message );

    return `https://web.whatsapp.com/send?${ params.toString() }`;
  }
}
